import React, { useState } from "react";
import { Button, Col, Form, Row } from "antd";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function SetupTenant({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <p>Complete each step carefully below</p>
          </Col>
          <Col span={24}>
            <p>
              -convert application to tenant by clicking button on right side of
              application if it is grayed out make sure and approve the
              screening report for all applicants
            </p>
          </Col>
          <Col span={24}>
            <p>
              -make sure and select the correct unit then enter the move in and
              lease start date as well as end date,
            </p>
          </Col>
          <Col span={24}>
            <p>-monthly rent,</p>
          </Col>
          <Col span={24}>
            <p>-Tenant Benefit Package - New($13)</p>
          </Col>
          <Col span={24}>
            <h3>-SN Insurance of $11.95</h3>
          </Col>
          <Col span={24}>
            <p>-pet fees and move in charge (security deposit )</p>
          </Col>
          <Col span={24}>
            <p>-unless using sayrhino service - see below</p>
          </Col>
          <Col span={24}>
            <p>
              -Enter a "Lease Prep fee" of $75 and use the lease prep gl account
              on the area for move in charges
            </p>
          </Col>
          <Col span={24}>
            <p>
              -Enter a $50 Security Deposit Waiver Admin Fee for any tenants
              that are doing the security deposit waiver program
            </p>
          </Col>
          <Col span={24}>
            <p>
              -enter a monthly fee on the gl account of Security Deposit waiver
              program. The amount will be a percentage of their rent based on
              the highest credit score in the household. so if their credit is
              800 and the rent is $1000 they would pay $30 per month. below is
              the breakdown if unsure how much to charge speak with Teresa or
              Rhett
            </p>
          </Col>
          <Col span={24}>
            <p>800-850 = 3% of monthly rent paid per month</p>
          </Col>
          <Col span={24}>
            <p>750-799 = 4% of monthly rent paid per month</p>
          </Col>
          <Col span={24}>
            <p>700-749 = 6% of monthly rent paid per month</p>
          </Col>
          <Col span={24}>
            <p>650-699 = 9% of monthly rent paid per month</p>
          </Col>
          <Col span={24}>
            <p>600-649 = 10% of monthly rent paid per month</p>
          </Col>
          <Col span={24}>
            <p>
              -click continue button to save the deposit charge if not done
              already during the process and then send the tenant the login from
              the tenant page so they can pay the deposit or first months rent
              if doing security deposit waiver program.
            </p>
          </Col>
          <Col span={24}>
            <p>
              -Once deposit or first months rent is paid take the house off the
              market in appfolio
            </p>
          </Col>
          <Col span={24}>
            <p>-go to calendar in appfolio and cancel all upcoming showings</p>
          </Col>
          <Col span={24}>
            <p>-prepare lease to send to applicant so they can sign</p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default SetupTenant;
